var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "#DB0000",
    stroke: "#DB0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.32 8.00026L11.7949 5.52535C12.0684 5.2519 12.0684 4.80856 11.7949 4.53554L11.465 4.2056C11.1914 3.93206 10.7481 3.93206 10.4751 4.2056L8.00026 6.68042L5.52535 4.20509C5.2519 3.93164 4.80856 3.93164 4.53554 4.20509L4.20509 4.53503C3.93164 4.80856 3.93164 5.2519 4.20509 5.52492L6.68042 8.00026L4.2056 10.4751C3.93206 10.7486 3.93206 11.192 4.2056 11.465L4.53554 11.7949C4.80899 12.0684 5.25232 12.0684 5.52535 11.7949L8.00026 9.32L10.4751 11.7949C10.7486 12.0684 11.192 12.0684 11.465 11.7949L11.7949 11.465C12.0684 11.1914 12.0684 10.7481 11.7949 10.4751L9.32 8.00026Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMark);
export default ForwardRef;